import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { AppState } from "../constants";
import useApplicationState from "./useApplicationState";
export default (function () {
  var _ref = useApplicationState(AppState.Device) || [{}],
    _ref2 = _slicedToArray(_ref, 1),
    device = _ref2[0];
  return device || {};
});